import MembershipController from '@club/customer/api/MembershipController'
import useRequestEffect from '@hooks/useRequestEffect'
import useAuth from '@hooks/useAuth'
import React from 'react'
import Table from '@components/modules/Table'
import MainContainer from '@blocks/MainContainer'
import columns from './config/columns'
import useStatic from '@hooks/useStatic'
import Breadcrumps from '@blocks/Breadcrumps'
import { confirmation, notify, route } from '@helpers'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import useMembersTableOptions from './hooks/useMembersTableOptions'

export default function MembersPage() {
    useTitle("Group: Members")
    useMainTemplate({ category: "club" })

    const auth = useAuth<Resources.ClubOwner>()
    const [members, setMembers] = useRequestEffect(() => MembershipController.index(auth.user.club.id))

    const heading = useStatic(<Breadcrumps items={[
        { name: auth.user.club.name, url: route("club:customer") }, 
        { name: "Members" }
    ]} />)

    const removeMember = useStatic(async (memberId: string | number) => {
        const confirmed = await confirmation("Are you sure you want to remove the member from your group?")
        if (!confirmed) return

        await MembershipController.destroy(auth.user.club.id, memberId)
        setMembers(old => old?.filter(member => member.id !== memberId))
        notify("The member was successfully removed from the group.")
    })

    const options = useMembersTableOptions(removeMember)

    return (
        <MainContainer heading={heading}>
            <Table data={members} columns={columns} options={options} />
        </MainContainer>
    )
}